(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallCheck', PhoneCallCheck);

    PhoneCallCheck.$inject = ['$resource', 'DateUtils'];

    function PhoneCallCheck ($resource, DateUtils) {
        var resourceUrl =  'api/phone-call-checks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.checkTime = DateUtils.convertDateTimeFromServer(data.checkTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
